import { Button, Checkbox, Form, Input, Popconfirm, Select, Space } from 'antd';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';
import { STAFF_PASSWORD_HINT, staffPasswordRule } from 'utils/password-policy';

const roleOptions = [
  { value: 'staff', label: 'Staff' },
  { value: 'admin', label: 'Admin' },
  { value: 'superadmin', label: 'Super Admin' },
];

const ItemForm = ({
  form,
  submiting,
  onFinish,
  initialValues,
  name,
  onDelete,
  deleting,
}: {
  form: any;
  submiting?: boolean;
  onFinish: (values: any) => void;
  initialValues?: any;
  name?: string;
  onDelete?: () => void;
  deleting?: boolean;
}) => {
  const isEdit = !!initialValues?.id;

  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'staff_account_form'}
      onFinish={values => onFinish(values)}
      initialValues={{
        role: 'staff',
        is_active: true,
        ...initialValues,
      }}
      scrollToFirstError
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[
          {
            required: true,
            type: 'email',
            message: 'Please input a valid email',
          },
        ]}
      >
        <Input disabled={isEdit} placeholder="staff@stag.vn" />
      </Form.Item>

      <Form.Item name="name" label="Name">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item
        name="title"
        label="Title"
        extra="Job title shown in customer-facing emails and reports."
      >
        <Input placeholder="" />
      </Form.Item>

      {!isEdit && (
        <Form.Item
          name="password"
          label="Password"
          extra={`Optional. Leave blank to let the user set password on first login. ${STAFF_PASSWORD_HINT}`}
          dependencies={['email']}
          rules={[staffPasswordRule(() => form.getFieldValue('email'))]}
        >
          <Input.Password placeholder="" autoComplete="new-password" />
        </Form.Item>
      )}

      <Form.Item
        name="role"
        label="Role"
        rules={[{ required: true, message: 'Please select a role' }]}
      >
        <Select options={roleOptions} />
      </Form.Item>

      <Form.Item name="is_active" label="Active" valuePropName="checked">
        <Checkbox />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Space>
          <Button type="primary" htmlType="submit" loading={submiting}>
            Save
          </Button>
          {onDelete && (
            <Popconfirm
              title="Delete this staff account?"
              description="This action cannot be undone."
              onConfirm={onDelete}
              okText="Delete"
              cancelText="Cancel"
              okButtonProps={{ danger: true }}
            >
              <Button danger loading={deleting}>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ItemForm;
